__turbopack_context__.v({
  "label": "TextButton-module-scss-module__qOrkFW__label",
  "large": "TextButton-module-scss-module__qOrkFW__large",
  "leadingIcon": "TextButton-module-scss-module__qOrkFW__leadingIcon",
  "medium": "TextButton-module-scss-module__qOrkFW__medium",
  "paddingCompact": "TextButton-module-scss-module__qOrkFW__paddingCompact",
  "paddingIconOnly": "TextButton-module-scss-module__qOrkFW__paddingIconOnly",
  "primary": "TextButton-module-scss-module__qOrkFW__primary",
  "secondary": "TextButton-module-scss-module__qOrkFW__secondary",
  "small": "TextButton-module-scss-module__qOrkFW__small",
  "tertiary": "TextButton-module-scss-module__qOrkFW__tertiary",
  "textButton": "TextButton-module-scss-module__qOrkFW__textButton",
  "trailingIcon": "TextButton-module-scss-module__qOrkFW__trailingIcon",
  "white": "TextButton-module-scss-module__qOrkFW__white",
  "xlarge": "TextButton-module-scss-module__qOrkFW__xlarge",
});
